<script setup lang="ts">
import dayjs from "dayjs";
import { computed } from "vue";
import type { FooterLink } from "@/models/footerLinks.model";

defineProps({
    links: {
        type: Array as () => FooterLink[],
        default: () => [],
    },
});

const currentYear = computed(() => dayjs().year());
</script>

<template>
    <footer class="app-footer">
        <div class="footer-container">
            <ul class="footer-nav">
                <li v-for="(link, i) in links" :key="i">
                    <a v-if="!link.isButton" :href="link.url" target="_blank">
                        {{ link.label }}
                    </a>
                    <a v-else role="button" class="ot-sdk-show-settings">
                        {{ link.label }}
                    </a>
                </li>
            </ul>
            <div class="footer-bottom">
                <p>© Legal &amp; General Group plc {{ currentYear }}</p>
            </div>
        </div>
    </footer>
</template>

<style scoped>
.app-footer {
    width: 100%;
    background-color: var(--primary-hover);
    color: var(--pure-white);
    text-align: center;
    padding: 0;
}

.footer-container {
    max-width: 1140px;
    margin: 0 auto;
    padding: 0 1rem;
}

.footer-nav {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
}

.footer-nav li {
    display: inline-block;
}

.footer-nav a {
    display: block;
    padding: 20px 30px 20px 0;
    font-size: var(--font-size-input);
    color: var(--pure-white);
    text-decoration: none;
    transition: color 0.3s ease;
}

.footer-bottom p {
    text-align: left;
    font-size: 12px !important;
    padding: 20px 0;
    margin-bottom: 0;
}

@media screen and (width <= 767px) {
    .app-footer {
        padding: 0;
    }

    .footer-nav {
        flex-direction: column;
        align-items: flex-start;
        border-top: 1px solid var(--off-white);
    }

    .footer-nav li {
        width: 100%;
    }

    .footer-nav a {
        padding: 15px 20px;
    }

    .footer-bottom p {
        text-align: center;
    }
}
</style>
